import { asyncAction } from 'lib/actions';

export const fetchCategoryAction = asyncAction('category/FETCH');
